import { useTabsContext } from '@core/hooks'
import { addSimpleNotification } from '@notifications/actions'
import type { MessageHandler } from 'common/messenger'
import { messengerRef } from 'common/messenger'
import type { FC } from 'react'
import { lazy, useEffect } from 'react'

import { getActiveEntity } from '../../helpers'
import {
  deleteMarkerFromProjectWells,
  selectActiveEntity,
  selectActiveProject,
  useAppDispatch,
  useAppSelector,
} from '../../store'
import type { MicrofrontendProps } from '../../types'
import { TabWrapper } from '../TabWrapper'
import { useCorrelationSchemeOrder } from './useCorrelationSchemeOrder'

const CorrelationSchemeFront = lazy(() => import('@correlationScheme/Main'))

export const CorrelationSchemeMF: FC<MicrofrontendProps> = props => {
  const dispatch = useAppDispatch()
  const entities = useTabsContext(props.tabId)
  const selectedTreeObject = useAppSelector(selectActiveEntity)
  const activeEntity = getActiveEntity(selectedTreeObject)
  const { id: projectId } = useAppSelector(selectActiveProject)
  const { sortedEntities } = useCorrelationSchemeOrder(entities, props.tabId, projectId)

  const allProps = {
    ...props,
    entities: sortedEntities,
    activeEntity,
    projectId,
    coreMessenger: messengerRef.current ?? undefined,
  }

  useEffect(() => {
    const onDeleteMarker: MessageHandler<'deleteMarkerFromProject'> = ({ payload }) => {
      const { entity, wellEntity, isDeleteFromOneWell } = payload
      if (!entity || (isDeleteFromOneWell && !wellEntity)) {
        addSimpleNotification({
          message: 'Не выбран маркер для удаления или скважина, с которой нужно удалить маркер',
          status: 'alert',
          autoClose: 10,
        })

        return
      }

      dispatch(
        deleteMarkerFromProjectWells({
          projectId,
          tabId: props.tabId,
          wellId: wellEntity?.entityId,
          markerEntity: entity,
        }),
      )
    }

    const unsubscribe = messengerRef.current?.subscribe('deleteMarkerFromProject', onDeleteMarker)
    return unsubscribe
  }, [])

  return (
    <TabWrapper>
      <CorrelationSchemeFront {...allProps} />
    </TabWrapper>
  )
}
